// extracted by mini-css-extract-plugin
module.exports = {"userAgentPreview":"UserAgentPreview_userAgentPreview__2EVsu","theme-for-table":"UserAgentPreview_theme-for-table__3Eawo","theme-for-rows":"UserAgentPreview_theme-for-rows__1FmTa"};